import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { myDataTypesStates } from '../../hooks/useMyDataTypesHook';

const mappingsActions = mapDefaultValuesToActions(myDataTypesStates);

export default reduxReducerHelper(mappingsActions, myDataTypesStates);
